module.exports = __webpack_public_path__ + "static/media/zheng1-4@3x.06832754.png";